module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar"
  }, [_c('ul', {
    staticClass: "menu-links"
  }, [_c('li', {
    staticClass: "menu-button",
    on: {
      "click": _vm.toggleMobileMenu
    }
  }, [_c('span', {
    staticClass: "menu-button-text"
  }, [_vm._v("Menu")])]), _vm._v(" "), _vm._l((_vm.$store.state.routerLinks), function(link, index) {
    return [_c('li', {
      staticClass: "nav-link"
    }, [_c('router-link', {
      staticClass: "no-style",
      attrs: {
        "to": link.path,
        "exact": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggleMobileMenu($event)
        }
      }
    }, [_vm._v(_vm._s(link.label))])], 1)]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f60e624a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 101
// module chunks = 4